import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from './base.service';
import { environment } from '../../environments/environment';
import { Customer } from '../models/Customer';
import { DsmRsmListItem } from '../models/DsmRsmListItem';
import { Product } from '../models/features/product/Product';
import { Division } from '../models/features/divisions/Division';
import { DsmRsmDetails } from '../models/features/dsm-rsm/DsmRsm';

@Injectable({
  providedIn: 'root',
})
export class CommonService extends BaseService<any> {
  constructor(http: HttpClient) {
    super(http, `${environment.apiUrl}/common/v1`);
  }

  public getRsaList(year: number): Observable<DsmRsmListItem[]> {
    const url = `${this.baseApiUrl}/dsmRsmList/R/${year}`;
    return this.httpClient.get<DsmRsmListItem[]>(url);
  }

  public getIsrList(year: number, filter: boolean = true): Observable<DsmRsmListItem[]> {
    const url = `${this.baseApiUrl}/dsmRsmList/D/${year}?rolefilter=${filter}`;
    return this.httpClient.get<DsmRsmListItem[]>(url);
  }

  public getIsrListByRsa(
    rsaCode: string,
    year: number,
  ): Observable<DsmRsmListItem[]> {
    const params = new HttpParams()
      .set('rsaCode', rsaCode)
      .set('companyYear', year);
    const url = `${this.baseApiUrl}/dsmListByRsa`;
    return this.httpClient.get<DsmRsmListItem[]>(url, { params });
  }

  public getCustomerListByIsr(
    isrCode: string,
    year: number,
  ): Observable<Customer[]> {
    const params = new HttpParams()
      .set('isrCode', isrCode)
      .set('companyYear', year);
    const url = `${this.baseApiUrl}/customerListByRsa`;
    return this.httpClient.get<Customer[]>(url, { params });
  }

  public getBrandsList(crop: string, year: number): Observable<Product[]> {
    const url = `${this.baseApiUrl}/products/?crop=${crop}&year=${year}`;
    return this.httpClient.get<Product[]>(url);
  }

  public getLotnosList(brandId: string, year: number): Observable<string[]> {
    const url = `${this.baseApiUrl}/lotno/?crop=${brandId}&year=${year}`;
    return this.httpClient.get<string[]>(url);
  }

  public getVarietyList(year: number): Observable<Product[]> {
    const url = `${this.baseApiUrl}/varietyList?year=${year}`;
    return this.httpClient.get<Product[]>(url);
  }

  public getProductList(year: number): Observable<Product[]> {
    const url = `${this.baseApiUrl}/productList?year=${year}`;
    return this.httpClient.get<Product[]>(url);
  }

  public getAvailableHybridProductList(year: number): Observable<Product[]> {
    const url = `${this.baseApiUrl}/availableHybridProductList?year=${year}`;
    return this.httpClient.get<Product[]>(url);
  }

  public getUserDivisionById(id: number): Observable<Division> {
    const url = `${this.baseApiUrl}/division/${id}`;
    return this.httpClient.get<Division>(url);
  }

   public getRsaByIsrCode(year: number, isrCode: string): Observable<DsmRsmDetails> {
    const url = `${this.baseApiUrl}/getRsaByIsr?isr=${isrCode}&year=${year}`;
    return this.httpClient.get<DsmRsmDetails>(url);
  }
}
